import { createCategory, type CategoryForm as CategoryFormValues } from '@gozoki/api'
import { useMutation } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'
import { CategoryForm } from '~/components/routes/categories/CategoryForm'
import { getAxiosErrorMessage } from '~/lib/utils'
import { usePermissionGuard, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/categories/new')({
  staticData: {
    permission: ['add', 'categories.categories.standard'],
  },
  component: AddCategoryPage,
})
withRoutePermissions(Route)

const EMPTY_CATEGORY: CategoryFormValues = {
  name: '',
  image: null,
  categoryId: null,
  description: '',
  rank: '0',
}

function AddCategoryPage() {
  const navigate = useNavigate()
  const canAdd = usePermissionGuard(['add', 'categories.categories.standard']).authorized

  const { mutateAsync: create } = useMutation({ mutationFn: createCategory })

  const navigateBack = () => navigate({ to: '/categories/categories' })

  return (
    <CategoryForm
      title="Ajouter une catégorie"
      submitLabel="Ajouter"
      canEdit={canAdd}
      defaultValues={EMPTY_CATEGORY}
      onCancel={navigateBack}
      onSubmit={async (values) => {
        try {
          await create(values)
          navigateBack()
        } catch (error) {
          toast.error(getAxiosErrorMessage(error))
        }
      }}
    />
  )
}
